import React from "react";
import TimeWithPopUp from "./TimeWithPopup";
import newlyadd from "./assets/newly_added.PNG"
import limSeats from "./assets/limitedSeats.PNG"
import intersession from "./assets/Intersession.PNG"

/* dangerouslySetInnerHTML is not actually dangerous here. It would be dangerous if the HTML would be generated based
on user input, which is not the case. */

class ClassCardBig extends React.Component {
  state = {
    starterCourses: ["LIBS 150", "PACE 111M", "WRTG 111"],
    showCourseDescr: false,
  };

  constructor(props) {
    super(props);
    this.toggleShowCourseDescr = this.toggleShowCourseDescr.bind(this);
    this.getCourseDescr = this.getCourseDescr.bind(this);
  }

  toggleShowCourseDescr() {
    this.setState({ showCourseDescr: !this.state.showCourseDescr });
  }

  getCourseDescr() {
    if (this.state.showCourseDescr) {
      return (
        <div className="mb-2">
          {this.state.showCourseDescr ? this.props.cls.DESCRIPTION : ""}
        </div>
      );
    } else {
      return null;
    }
  }

  getCourseDescrSwitch() {
    return this.state.showCourseDescr ? (
      <i className="fas fa-caret-up"></i>
    ) : (
      <i className="fas fa-caret-down"></i>
    );
  }

  render() {
    let addToCompareButton = null;
    if (
      this.props.compares.length < 3 &&
      !this.props.compares.includes(this.props.cls)
    ) {
      addToCompareButton = (
        <button
          id={this.props.cls.CLASS_NBR}
          onClick={this.props.addCompare}
          className="btn btn-primary btn-sm d-print-none"
        >
          Add to compare
        </button>
      );
    } else {
      addToCompareButton = (
        <button
          id={this.props.cls.CLASS_NBR}
          className="btn btn-primary btn-sm btn-light d-print-none"
        >
          Add to compare
        </button>
      );
    }
// Show default codes
    // let instructionMode = "";

    // switch (this.props.cls.IM) {
    //   case "WT":
    //     instructionMode = "Online";
    //     break;
    //   case "TN":
    //   case "OV":
    //   case "VO":
    //     instructionMode = "Online Virtual";
    //     break;
    //   case "P":
    //   case "PC":
    //   case "LP":
    //   case "HY":
    //   case "HC":
    //   case "LH":
    //   case "LC":
    //     instructionMode = "On-site";
    //     break;
    //   case "FS":
    //     instructionMode = "Field Study";
    //     break;
    //   case "LZ":
    //   case "HZ":
    //   case "PZ":
    //   case "LF":
    //   case "HF":
    //   case "PF":
    //     instructionMode = "On-site Flex";
    //     break;
    //   default:
    //     instructionMode = this.props.cls.IM;
    // }

    let instructionMode = "";
    instructionMode = this.props.cls.IM;

    return (
      <div className="card mb-2">
        <div className="card-header">
          <button
            className="btn btn-secondary btn-sm d-print-none"
            onClick={this.toggleShowCourseDescr}
          >
            {this.getCourseDescrSwitch()}
          </button>
          &nbsp;
          <span
            dangerouslySetInnerHTML={{
              __html: (this.props.cls.S + this.props.cls.CN).replace(
                new RegExp(this.props.searchFilter, "gi"),
                "<b>$&</b>"
              ),
            }}
          />{" "}
          -{" "}
          <span
            dangerouslySetInnerHTML={{
              __html: this.props.cls.T.replace(
                new RegExp(this.props.searchFilter, "gi"),
                "<b>$&</b>"
              ),
            }}
          />
          &nbsp;({this.props.cls.CR} credit hours)
          <div
            className="float-right"
            style={{ position: "absolute", bottom: 5, right: 5 }}
          >
            {addToCompareButton}
          </div>
        </div>
        <div className="card-body">
        {/*YO:  Winter Intersession image  10/19/2023 */} 
        <p>
            <small> {this.props.cls.NT.length > 1 && this.props.cls.NT.includes("intersession") ? (
                  <>
                  <div>
                    <img width="200-%" src={intersession} alt="" />
                    </div>
                  </>
                ) : null}
                </small>
                </p>


          {/*YO:  NEwly Added image  8/09/2023 */} 
           <p>
            <small> {this.props.cls.NT.length > 1 && this.props.cls.NT.includes("Newly Added!") ? (
                  <>
                  <div>
                    <img width="150-%" src={newlyadd} />
                    </div>
                  </>
                ) : null}
                </small>
                </p>

        {/*YO: LimitedSeats image if it is 5 or less  8/09/2023 */} 

        <p>
            <small> {this.props.cls.SEATS <=5 && this.props.cls.SEATS > 0 ? (
                  <>
                  <div>
                    <img width="200-%" src={limSeats} />
                    </div>
                  </>
                ) : null}
                </small>
                </p>

          {this.getCourseDescr()}
          <div className="row">
            {this.state.starterCourses.includes(
              this.props.cls.S + this.props.cls.CN
            ) ? (
              <p class="starter-classes">
                <small>
                  {" "}
                  <span class="starter-classes-highlight">*</span> This class is
                  great for new students.
                </small>
              </p>
            ) : (
              ""
            )}
          </div>
          <div className="row">
            <div className="col-sm">
              <em>Location: </em>
              <span
                dangerouslySetInnerHTML={{
                  __html: this.props.cls.LOC_D.replace(
                    new RegExp(this.props.searchFilter, "gi"),
                    "<b>$&</b>"
                  ),
                }}
              />
              <br />
              <em>Class number: </em>
              {this.props.cls.CLASS_NBR}
              <br />
              <em>Section: </em>
              {this.props.cls.CS}
              {/* <br />
                            <em>{this.props.cls.IM === "" ? null : 'Instruction mode: '}</em>
                            {instructionMode} */}
            </div>
            <div className="col-sm">
              <em>Faculty: </em>
              <span
                dangerouslySetInnerHTML={{
                  __html: this.props.cls.FAC.replace(",", ", ").replace(
                    new RegExp(this.props.searchFilter, "gi"),
                    "<b>$&</b>"
                  ),
                }}
              />
              <br />
              <em>Status: </em>
              {this.props.cls.ES === "O"
                ? "Open"
                : this.props.cls.LOC === "WEB"
                ? "Closed"
                : "Waitlist available"}
              <br />
              {new Date().setDate(new Date().getDate() + 21) >=
              new Date(this.props.cls.START_DT) ? (
                <a
                  href={
                    "https://api.apidapter.com/v0/umgc/soc?course_external_id=" +
                    this.props.cls.CI +
                    "-0" +
                    this.props.cls.CO +
                    "-" +
                    this.props.cls.STRM +
                    "-" +
                    this.props.cls.SC +
                    "-" +
                    this.props.cls.CS
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  Syllabus
                </a>
              ) : (
                <span>Syllabus 3 wks prior to start</span>
              )}
              <br />
              {/* <em>{this.props.cls.LOC.substring(0, 1) === "E" ? null : this.props.cls.SEATS === -99 ? null : 'Seats available: ' + Math.max(this.props.cls.SEATS, 0)}</em><br /> */}
            </div>
            <div className="col-sm">
              {new Date(this.props.cls.START_DT).toLocaleDateString("en-US")} -{" "}
              {new Date(this.props.cls.END_DT).toLocaleDateString("en-US")}
              <br />
              {this.props.cls.MON === "Y" ||
              this.props.cls.TUES === "Y" ||
              this.props.cls.WED === "Y" ||
              this.props.cls.THURS === "Y" ||
              this.props.cls.FRI === "Y" ||
              this.props.cls.SAT === "Y" ||
              this.props.cls.SUN === "Y" ? (
                <em>Days: </em>
              ) : null}
              {this.props.cls.MON === "Y" ? "Mon " : ""}
              {this.props.cls.TUES === "Y" ? "Tue " : ""}
              {this.props.cls.WED === "Y" ? "Wed " : ""}
              {this.props.cls.THURS === "Y" ? "Thu " : ""}
              {this.props.cls.FRI === "Y" ? "Fri " : ""}
              {this.props.cls.SAT === "Y" ? "Sat " : ""}
              {this.props.cls.SUN === "Y" ? "Sun " : ""}
              <TimeWithPopUp
                cls={this.props.cls}
                downrangeLocations={this.props.downrangeLocations}
                showLabel="true"
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              {/* Combine Instruction mode and notes on one line */}
              {/* <em>{this.props.cls.IM === "" ? null : "Instruction mode: "}</em>
              {instructionMode}
              <em>{this.props.cls.IM === "" ? null : " / "}</em> */}

              <span>
                {this.props.cls.NT.length > 1 ? (
                  <>
                    <em>Note: </em>
                  </>
                ) : null}
              </span>
              <span
                dangerouslySetInnerHTML={{
                  __html: this.props.cls.NT.replace(
                    new RegExp(this.props.searchFilter, "gi"),
                    "<b>$&</b>"
                  ),
                }}
              />
              <span className="d-lg-none d-print-none">
                <br />
                <br />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClassCardBig;
